import type { StateCreator } from 'zustand'
import type { Company } from '@/types/company'

export interface CompanyState {
	company: Company | null
	setCompany: (company: Company | null) => void
}

export const createCompanyState: StateCreator<CompanyState> = (set) => ({
	company: null,
	setCompany: (company) => set({ company }),
})
